import React from "react";
import HostUserProfile from "./HostUserProfile";
import "./profileinfo.css";

const UserInformation = () => {
  return <HostUserProfile />;
};

export default UserInformation;
